import { apiFetch } from './client';

export const listSampleFiles = () => apiFetch('/scans/sample-files');

export const importScanFile = (filename) =>
  apiFetch('/scans/import', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ filename }),
  });

export const uploadScanFile = (file) => {
  const form = new FormData();
  form.append('file', file);
  return apiFetch('/scans/upload', { method: 'POST', body: form });
};
